import useInternalLinks from '@/hooks/useInternalLinks';
import { useLocation } from '@reach/router';

const defaultLinkExtractor = (link: Queries.LINKFragment) => link;

type UseActiveLinkProps<T> = T extends Queries.LINKFragment
  ? {
      links: ReadonlyArray<T> | Array<T>;
      linkExtractor?: never;
    }
  : {
      links: ReadonlyArray<T> | Array<T>;
      linkExtractor: (link: T) => Queries.LINKFragment;
    };

const useActiveLink = <T>({ links, linkExtractor }: UseActiveLinkProps<T>) => {
  const { pathname: currentPathname } = useLocation();
  const getInternalLinkURLByCodename = useInternalLinks();
  const extractor = typeof linkExtractor === 'undefined' ? defaultLinkExtractor : linkExtractor;

  return links.find((link) => {
    const extractedLink = extractor(link);
    if (
      extractedLink.linkElements.action.value.__typename !==
      'kontent_item_link_action_internal_page'
    ) {
      return false;
    }

    const codename = extractedLink.linkElements.action.value.elements.page.value.system.codename;

    return getInternalLinkURLByCodename(codename) === currentPathname;
  });
};

export default useActiveLink;
